import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/visites`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const countVisites = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countVisites`, {
      headers: authHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du nombre de visites:", error);
    return { count: 0 };
  }
};

export const countVisitesByDate = async () => {
  try {
    const response = await axios.get(`${apiUrl}/countVisitesByDate`, {
      headers: authHeaders(),
    });

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error(
      "Erreur lors de la récupération du nombre de visites par date:",
      error
    );
    return [];
  }
};

export const saveVisite = async (visite = {}) => {
  try {
    const response = await axios.post(`${apiUrl}/addVisite`, visite, {
      headers: authHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de la visite:", error);
    return null;
  }
};

export const deleteVisitesByDate = async (dateDebut, dateFin) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteVisites`, {
      headers: authHeaders(),
      data: { dateDebut, dateFin },
    });

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression des visites par date:", error);
    throw error;
  }
};